(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('execute-alert-notifications', {
            parent: 'entity',
            url: '/execute-alert-notifications',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.executeAlertNotifications.executeAlertNotifications" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/execute-alert-notifications/execute-alert-notifications.html',
                    controller: 'ExecuteAlertNotificationsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('executeAlertNotifications');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })

        };
    })();